import { useTranslation } from 'react-i18next';

export default function ProjetsRecents() {
  const { t } = useTranslation('charny');

  const projets = [
    {
      title: t('projet_1_title'),
      desc: t('projet_1_desc'),
      img: "https://readdy.ai/api/search-image?query=Century-old%20Quebec%20house%20on%20a%20quiet%20street%20with%20newly%20restored%20metal%20roofing%2C%20historic%20worker%20home%20with%20traditional%20character%2C%20authentic%20neighborhood%20setting%2C%20warm%20afternoon%20light%2C%20slate%20blue%20and%20copper%20color%20palette%2C%20residential%20street%20photography&width=400&height=300&seq=charny-projet-1&orientation=landscape",
      alt: "restauration toiture maison historique Charny rue de la Gare",
    },
    {
      title: t('projet_2_title'),
      desc: t('projet_2_desc'),
      img: "https://readdy.ai/api/search-image?query=Flat%20roof%20replacement%20on%20a%20Quebec%20duplex%20building%20with%20modern%20elastomeric%20membrane%2C%20two-story%20residential%20building%2C%20professional%20roofing%20work%20visible%2C%20urban%20street%20setting%2C%20muted%20colors%20with%20copper%20and%20slate%20accents%2C%20authentic%20photography%20style&width=400&height=300&seq=charny-projet-2&orientation=landscape",
      alt: "toit plat duplex Charny rue Commerciale",
    },
    {
      title: t('projet_3_title'),
      desc: t('projet_3_desc'),
      img: "https://readdy.ai/api/search-image?query=Modern%20bungalow%20house%20in%20Quebec%20with%20new%20architectural%20asphalt%20shingle%20roof%2C%20suburban%20residential%20area%20near%20highway%2C%20clean%20landscaping%2C%20bright%20daylight%2C%20slate%20blue%20sky%20with%20warm%20earth%20tones%2C%20copper%20roof%20accents%20on%20vents%2C%20authentic%20real%20estate%20photography%20style&width=400&height=300&seq=charny-projet-3&orientation=landscape",
      alt: "toiture bungalow Charny secteur autoroute 20",
    },
  ];

  return (
    <section className="py-14 md:py-20 bg-white">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-bold text-[#1B2A4E] mb-8 md:mb-10 text-center">
          {t('projets_h2')}
        </h2>

        <div className="grid grid-cols-1 md:grid-cols-3 gap-5 md:gap-6">
          {projets.map((p, idx) => (
            <div
              key={idx}
              className="bg-white rounded-lg border border-gray-100 overflow-hidden hover:border-[#C77D3F]/30 transition-colors"
            >
              <div className="h-[200px] md:h-[220px] overflow-hidden">
                <img
                  src={p.img}
                  alt={p.alt}
                  className="w-full h-full object-cover object-top"
                  loading="lazy"
                  width="400"
                  height="300"
                />
              </div>
              <div className="p-4 md:p-5">
                <h3 className="text-base font-semibold text-[#1B2A4E] mb-1">{p.title}</h3>
                <p className="text-sm text-[#4A5568] leading-relaxed">{p.desc}</p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}